import React, { Component } from 'react'
import { Row, Col, Table, Image, Button, Container, Accordion, Card, Form, Tooltip, OverlayTrigger, Modal } from 'react-bootstrap';
import { components } from 'react-select'
import * as Cookies from "es-cookie";
import moment from 'moment';
import * as compose from 'lodash.flowright';
import './_studentAdmission.scss';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';

class StudentAdmissionListHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch: "",
            loadingSpinner: 0,
            getAdmissionStudentList: [],
            branchError: "",
            is_submitted: false
        }
    }


    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value, branchError: "", getAdmissionStudentList: [], is_submitted: false });
    };


    getStudentAdmissionList = async () => {


        if (this.state.branch == "") {
            this.setState({ branchError: "Please select branch" })
            return ""
        }

        this.setState({ loadingSpinner: 1 })

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,){
                getAdmissionStudentList(institute_id:$institute_id,branch_id:$branch_id){
                    id
                    student_name
                    admission_no
                    father_contact_no
                  }
            }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch),
            }
        })

        console.log("dddd", result.data);
        if (result.data.getAdmissionStudentList.length > 0) {
            this.setState({
                getAdmissionStudentList: result.data.getAdmissionStudentList,
                loadingSpinner: 0,
            })

        } else {
            this.setState({
                getAdmissionStudentList: [],
                loadingSpinner: 0,
                is_submitted: true
            })
        }
    }


    view(cell, row) {
        console.log("helllo", cell, row);
        return (
            <>
                <Button className="text-uppercase submit_btn " name="view" onClick={(e) => this.veiwOrEditRedict(e, row)}>View</Button>
            </>
        )
    }
    edit(cell, row) {
        return (
            <>
                <Button className="text-uppercase submit_btn" name="edit" onClick={(e) => this.veiwOrEditRedict(e, row)} >Edit</Button>
            </>
        )
    }


    veiwOrEditRedict(e, row) {

        console.log("redict", e.target.name, row);
        let name = e.target.name;

        this.props.history.push({
            pathname: "/student-admission",
            state: {
                name: name,
                student_id: row.id,
                branch_id: this.state.branch,
                admission_no: row.admission_no
            }
        });

    }
    articlecolumns = [
        {
            dataField: "admission_no",
            text: "Admission Number",
        },
        {
            dataField: "student_name",
            text: "Student Name",
        },
        {
            dataField: "father_contact_no",
            text: "Father Mobile",
        },
        {
            text: "View",
            formatter: this.view.bind(this)
        },
        {
            text: "Edit",
            formatter: this.edit.bind(this)
        },
    ];

    render() {
        console.log("list", this.state);
        return (
            <Container className="student_admission_list">
                <Row className="mt-3">
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                            <h2 className="title h5 mb-0">Student Admission List</h2>
                        </div>
                    </Col>
                    <Col sm={12}>
                        <Form>
                            <Form.Row>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranchName">
                                    <Form.Label className="text-uppercase font-weight-bold">Select Branch</Form.Label>
                                    <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch}>
                                        <option value="">--Select Branch--</option>
                                        {this.props.globals.globalBranches.map(branchData => (
                                            <option value={branchData.id}>{branchData.branch_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.branchError}
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranch">
                                    <Button className="text-uppercase submit_btn mt-30" onClick={(e) => this.getStudentAdmissionList()}>Submit</Button>
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </Col>
                </Row>

                {
                    this.state.getAdmissionStudentList.length > 0 ?
                        (
                            <>
                                <Row>
                                    <Col sm={12}>
                                        <CardLessDataTable
                                            parentData={this.state.getAdmissionStudentList}
                                            particlecolumns={this.articlecolumns}
                                            name="admissionList"
                                            searchBar={true}
                                        />
                                    </Col>
                                </Row>
                            </>
                        )
                        :
                        (
                            <Container>
                                <Row>
                                    <Col sm={12}>
                                        <div className={this.state.loadingSpinner == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""} >
                                        </div>
                                    </Col >
                                </Row>
                                <Row>
                                    <Col>
                                        {
                                            this.state.is_submitted ? (
                                                <h6 className=' text-center mt-5'> No data found</h6>
                                            ) : ("")
                                        }
                                    </Col>
                                </Row>
                            </Container >
                        )
                }

            </Container>
        )
    }
}

export default withRouter(withApollo(
    compose(

    )(StudentAdmissionListHome))
);

